import React from "react"
import { Select, Spin } from "antd"
import { debounce } from "lodash"

export function DebounceSelect({ fetchOptions, debounceTimeout = 800, ...props }) {
  const [fetching, setFetching] = React.useState(false)
  const [options, setOptions] = React.useState([])
  const fetchRef = React.useRef(0)

  const debounceFetcher = React.useMemo(() => {
    const loadOptions = (value) => {
      fetchRef.current += 1
      const fetchId = fetchRef.current
      setOptions([])
      setFetching(true)
      fetchOptions(value).then((newOptions) => {
        const result = []
        newOptions.data.products.forEach((product) => {
          result.push({
            label: `${product.guid} - ${product.name}`,
            value: product.id,
          })
        })
        if (fetchId !== fetchRef.current) {
          // for fetch callback order
          return
        }
        setOptions(result)
        setFetching(false)
      })
    }
    return debounce(loadOptions, debounceTimeout)
  }, [fetchOptions, debounceTimeout])

  return (
    <Select
      labelInValue
      filterOption={false}
      onSearch={debounceFetcher}
      notFoundContent={
        <span style={{ display: 'flex', justifyContent: 'center' }}>
                  {fetching ? <Spin size="small" /> : 'Ничего не найдено'}
              </span>
      }
      {...props}
      options={options}
    />
  )
}
